<template>
    <div id="mobileMyExam">
        <div class="headerExam">
             <div class="categories-tree-item flex align-cen">
                            <div class="jstree-node" v-for="(item,index) in options" :key="item.id"
                        :class="index == textActive  ? 'treeactive': ''"
                        @click="swichTopic(index)"
                        >
                            <span>{{item.name}}</span>
                        </div>
                        </div>
        </div>
        <div class="table-toolbar">
            <div class="regulaOptionBox flex">
                    <div class="regulaOption mft" v-if="btnactive == 0">
                                    <el-select v-model="regulaTagValue"  clearable placeholder="考试状态"
                                   @change="getCentList"
                                    >
                                        <el-option
                                        v-for="item in regulaTag"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.state">
                                        </el-option>
                                    </el-select>
                                </div>
                                   <div class="regulaOption mft" v-if="btnactive == 1">
                                    <el-select v-model="regulaTagValue2"  clearable placeholder="分数"
                                     @change="getCentList1"
                                    >
                                        <el-option
                                        v-for="item in regulaTag2"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.state">
                                        </el-option>
                                    </el-select>
                                </div>
            </div>
                     <div class="exams-list">
                            <div class="exams-scrollbar flex" v-if="examList.length">
                                 <!-- -->
                                <div class="exams-item" v-for="(item,index) in examList" >
                                    <div class="exams-item-paperName">
                                        {{item.paperName}}
                                    </div>
                                    <div class="exams-item-info">
                                        <img :src="item.logo" alt="">
                                        <div class="exams-item-info-rule">
                                            <div v-if="btnactive == 0">
                                            <p v-if="item.validPeriod == '2'" class="flex">考试时间：<span class="mft">永久有效</span></p>
                                            <p v-if="item.validPeriod == '1'" class="flex">考试时间：
                                                <el-tooltip class="item" effect="dark" :content="`${item.showFromTime}~${item.showUntilTime}`" placement="top"> 
                                                <span class="mft">
                                                    {{item.showFromTime}}~{{item.showUntilTime}}
                                                </span>
                                               </el-tooltip>
                                            </p>
                                           <p class="flex align-cen">考试次数：
                                            <span class="mft">
                                                {{getAanswerNumType(item.answerNumType,item.answerNum,1)}}
                                            </span>
                                           </p>
                                           <p class="flex">
                                            考试限时:
                                            <span class="mft">{{item.timeLimit}}分钟</span>
                                           </p>
                                           <p class="flex">
                                            考试总分:
                                            <span class="mft">{{item.paperScore}}分</span>
                                           </p>
                                           <p class="flex">
                                            及格分数:
                                            <span class="mft">{{item.passmark}}%</span>
                                           </p>
                                           </div>
                                           <div v-if="btnactive == 1">
                                             <p  class="flex">考试时间：
                                                <span class="mft">{{item.startTime}}</span>
                                             </p>
                                             <p  class="flex">用时：
                                                <span class="mft">{{convertSecondsToMinutes(item.doTime,1)}}</span>
                                             </p>
                                             <p  class="flex">得分比：
                                                <span class="mft">{{Number(item.scoreRate)}}%</span>
                                             </p>
                                           </div>
                                     <div class="tipImg" v-if="btnactive == 0">
                                        <img src="../../assets/images/examNow.png" alt="" v-if="item.state == 1" class="jxz">
                                         <img src="../../assets/images/examno.png" alt="" v-if="item.state == 0">
                                          <img src="../../assets/images/examend.png" alt="" v-if="item.state == 2">
                                    </div>
                                     <div class="tipImg" v-if="btnactive == 1">
                                        <img src="../../assets/images/exampass.png" alt="" v-if="item.result == 1">
                                         <img src="../../assets/images/examnopass.png" alt="" v-if="item.result == 0">
                                         <img src="../../assets/images/pjz.png" alt="" v-if="item.result == 2">
                                    </div>
                                        </div>
                                    </div>
                                    <div class="exams-item-line"></div>
                                    <div class="flex" style="justify-content:end" v-if="btnactive == 0">
                                        <div class="exams-item-btn" v-if="item.state == 1" @click="openExamlogin(item)">进入考试</div>
                                         <div class="exams-item-btn exams-item-btn1" v-if="item.state == 2">已考完</div>
                                          <div class="exams-item-btn exams-item-btn1" v-if="item.state == 0">未开始</div>
                                    </div>
                                    <div class="flex" style="justify-content:end" v-if="btnactive ==1">
                                        <div class="exams-item-btn" @click="getResulttRanscript(item)">查看成绩</div>
                                    </div>
                                </div>
                            </div>
                            <div class="exams-scrollbar" v-else>
                                <el-empty>
                            </el-empty>
                            </div>
                        </div>
        </div>
        <div class="footerExam flex align-cen">
            <div class="btnexam" :class="btnactive == 0 ? 'btnactive' : ''" @click="addclass(0)">
                 <div class="btnexam-icon"><i class="icon-al-edit"></i></div>
                 <div class="btnexam-text">开始做题</div>
                </div>
          <div class="btnexam" :class="btnactive == 1 ? 'btnactive' : ''" @click="addclass(1)">
            <div class="btnexam-icon"><i class="icon-al-file-fill"></i></div>
                 <div class="btnexam-text">考试记录</div>
          </div>
        </div>
          <el-dialog
  title="查看成绩单"
  :visible.sync="centerDialogVisible"
  width="100%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass paperDialogClass"
  v-if="centerDialogVisible"
  >
    <el-tabs  v-model="activeName">
        <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">{{testerInfo.paperName}}</p>
                    <p class="text">考试者：{{testerInfo.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo.startTime}} | 交卷时间：{{testerInfo.answerTime}} 
                    </p>
                   <div class="sorceRow">
                        <div class="result-scores">
                            <div class="exam-record-info" v-if="testerInfo.result !=2">
                                <p class="score-num">{{testerInfo.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf">(试卷总分{{testerInfo.paperScore}}分)</div>
                            <div class="reult2" v-if="testerInfo.result ==2">
                                <div class="reult2_tip">答题已结束，感谢您的参加</div>
                                <div class="reult2_pj">请等待老师批卷，批卷完成后将展示成绩</div>
                            </div>
                             <div class="zf">用时：{{convertSecondsToMinutes(testerInfo.doTime,2)}}</div>
                                  
                             <div class="pass-message">
                                <!-- <div class="public-tit flex align-cen">
                                    <div class="public-tit-list">
                                        <i class="icon-al-question-circle"></i> 
                                    </div>
                                </div> -->
                                <p >
                                    <span> 教师评语：</span>
                                    <span v-html="testerInfo.comment || '无'"></span>
                                </p>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio" @change="getQuestionListCom(radio)">
      <el-radio-button label="1">
        答对（{{testerInfo.rightNum}}）
      </el-radio-button>
        <el-radio-button label="5" v-if="testerInfo.result == 2">
        未批改（{{testerInfo.uncorrectedNum}}）
        </el-radio-button>
      <el-radio-button label="2">
        答错（{{testerInfo.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        未答（{{testerInfo.unAnswerNum}}）
      </el-radio-button>
      <el-radio-button label="4">
        全部试题（{{testerInfo.questionNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList.length">
                    <div class="row" v-for="(item,index) in questionList" :key="item.id">
                        <div class="ques-title flex align-cen">
                            <span class="ques-number">{{index+1}}.</span>
                            <span class="ques-type">
                                {{$util.getTopicType(item.type)}}
                            </span>
                            <span v-html="item.title" :class="item.type == 9 ? 'clozeClass' : ''"></span>
                            <span class="ques-score">（{{item.questionScore}}分）</span>
                        </div>
                          <div class="question-option-list">
                            <ol v-if="item.type != 9 && item.type != 5">
                                <li v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                    <p v-html="sonitem.content"></p>
                                </li>
                            </ol>
                             <div class="refAnswer"  v-if="item.type == 5" style="margin-left:-25px">
                              <div class="detailKeyWorld" v-if="item.rule">
                                  <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                  <p>关键字：</p>
                                      <p v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                      {{sonitem.content}}<span v-if="sonIndex !=item.questionAnswerList.length-1">，</span>
                                  </p>
                                  </div>
                              </div>
                              <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                          </div>
                            <div class="clzoe" v-if="item.type == 9">
                                <div class="clzoeItem" v-for="(sonitem,sonIndex) in item.questionAnswerList" :key="sonIndex">
                                <p class="cloze-op-p" style="margin-left:-25px">
                                    <strong> {{sonIndex + 1}}:</strong>
                                </p>
                                <ol >
                                    <li  v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                        <p v-html="sonitem1.content"></p>
                                    </li>
                                </ol>
                                </div>
                            </div>
                          </div>
                        <div class="ques-answers">
                            <div class="test_result flex align-cen">
                                <div class="userAnswer">
                                    <div class="test_result_span_title">考生答案：</div>
                                    <strong :class="item.doRight == 1 ? 'true' : 'false'" v-if="item.isAnswer == '1'">
                                        {{item.answerContent}}
                                        <i :class="item.doRight == 1 ? 'icon-al-check' : 'icon-al-times'"></i>
                                    </strong>
                                    <span v-else>未作答</span>
                                </div>
                                <div class="rightAnswer" v-if="item.type != 7 && item.type != 9 && item.type != 5">
                                     <div class="test_result_span_title">正确答案：</div>
                                        <div class="dnl flex">
                                            <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                        <strong  v-if="sonitem.isRight == 1">
                                        {{Eng[sonIndex]}}
                                    </strong>
                                    </span>
                                    </div>
                                </div>
                                   <div v-if="item.type == 5" class="flex align-cen rightAnswer" style="color:#009aff">
                                     参考答案：
                                  <span v-html="item.refAnswer"></span>
                                </div>
                                 <div v-if="item.type == 7" class="rightAnswer">
                                    正确顺序：
                                    <span v-for="(sonitem,sonIndex) in item.sortedIndexes">
                                        <span>
                                        {{Eng[sonitem]}}
                                    </span>
                                    </span>
                                </div>
                                  <div v-if="item.type == 9" class="rightAnswer">
                                    正确答案：
                                    <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                                <span style="margin-right:20px">
                                                {{sonIndex + 1}}:
                                                <span v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                                    <span v-if="sonitem1.isRight == 1">{{Eng[sonIndex1]}}</span>
                                                </span>
                                                </span>
                                    </span>
                                </div>
                                <div class="score">
                                    <div class="test_result_span_title">分数：</div>
                                    <strong style="color: #36aafd">
                                        {{item.customerScore}} / {{item.questionScore}}分
                                    </strong>
                                </div>
                            </div>
                        </div>
                          <div class="jx flex align-cen">
                            题目解析：<span v-html="item.analysis || '暂无解析'"></span>
                         </div>
                    </div>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>
</template>
<script> 
import {centList,centLog,resulttRanscript} from "@/api/enterprise/index"   //考试列表、考试记录
export default {
    name:'testingCenter',
    data () {
        return {
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            centerDialogVisible:false,
            radio:'1',
            questionList:[],
            resultQuestionVOList:[],
            testerInfo:{},
            activeName:'1',
            examList:[],
            businessInfo:{},
            regulaTag:[
                 {
                    state:'',
                    name:'全部'
                },
                {
                    state:'0',
                    name:'未开始'
                },
                {
                    state:'1',
                    name:'考试中'
                },
            ],
            regulaTag1:[

                {
                    state:'0',
                    name:'正在考试'
                },
                {
                    state:'1',
                    name:'练习考试'
                },
            ],
             regulaTag2:[
                {
                    state:'',
                    name:'全部'
                },
                {
                    state:'0',
                    name:'未通过'
                },
                {
                    state:'1',
                    name:'已通过'
                },
            ],
            regulaTagValue:'',
            regulaTagValue1:'0',
            regulaTagValue2:'',
            title:'考试中心',
            btnactive:0,
            textActive:0,
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            options:[
                {
                    name:'正式考试',
                    id:0
                },
                {
                  name:'练习考试',
                  id:1   
                }
            ]
        }
    },
    created() {
        document.title = '考试中心'
         if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
         this.getCentList()
    },
    methods: {
              convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
        // 判断是否为选择题
        getQueType(type){
        },
        // 获取考试次数
        getAanswerNumType(type,num,fnType){
            // fnType = 1 表示考试次数、 2、表示题型判断
            const actionTypelanes = {
                0:'无限次',
                1:fnType == 1 ? '一次' : fnType == 2 ? '单选题' : '',
                2:fnType == 1 ? `多次（${num}次）` : fnType == 2 ? '多选题' : '',
                3:fnType == 1 ? `每天每人（${num}）次` : fnType == 2 ? '判断题' : '',
                4:fnType == 1 ? '' : fnType == 2 ? '填空题' : ''
            }
            return actionTypelanes[type] || ''
        },
        // 打开进入考试
        openExamlogin(data){
             this.$router.push({
            name:'examLogin',
            query:{
                id:data.paperId,
                businessId:this.businessInfo.id
            }
            })
        },
                convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
           // 获取成绩单
        getResulttRanscript(data){
            this.centerDialogVisible = true
            this.activeName = '1'
            this.resultQuestionVOList = []
            this.questionList = []
            this.radio = '1'
            resulttRanscript({id:data.resultId}).then(res => {
                this.testerInfo = res.data
                this.resultQuestionVOList = res.data.resultQuestionVOList
                        this.resultQuestionVOList.forEach(k =>{
                if(k.type == 9){
                  k.questionAnswerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.questionAnswerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              })
                this.resultLogList = res.data.resultLogList
                this.getQuestionListCom(1)
            })
        },
           getQuestionListCom(type){
            this.questionList = []
                this.resultQuestionVOList.forEach(k =>{
                if(k.type == 9){
                  k.questionAnswerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.questionAnswerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              })
          if(type == 1){
            for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 2){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 3){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 4){
                this.questionList = this.resultQuestionVOList
             }else if(type == 5){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].doRight =='2' && this.resultQuestionVOList[key].isAnswer =='1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
             }else{
                this.questionList = []
             }
        },
        // 获取考试列表
        getCentList(){
            let params = {
                businessId:this.businessInfo.id,
                state:this.regulaTagValue,
                practiceMode:this.regulaTagValue1,
                result:this.regulaTagValue2,
            }
            centList({...params})
            .then(res =>{
                this.examList = res.data
            })
        },
        // 获取记录
          getCentList1(){
            let params = {
                businessId:this.businessInfo.id,
                state:this.regulaTagValue,
                practiceMode:this.regulaTagValue1,
                result:this.regulaTagValue2,
            }
            centLog({...params})
            .then(res =>{
                this.examList = res.data
            })
        },
        swichTopic(index){
            this.textActive = index
            this.regulaTagValue1 = index
            if(this.btnactive == 0){
                this.getCentList()
            }else{
                this.getCentList1()
            }
        },
        addclass(index){
            this.examList = []
            this.btnactive = index
               this.regulaTagValue2 =''
                this.result = ''
                this.practiceMode = '0'
                this.regulaTagValue = ''
            if(index == 0){
                this.getCentList()
            }else{
                this.getCentList1()
            }
        },
    },
}
</script>
<style lang="scss" scoped>
#mobileMyExam{
    position: relative;
    background: #fff;
    .headerExam{
         position: fixed;
        left: 0;
        top: 56px;
        height: 50px;
        background-color: white;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
         width: 100%;
         z-index: 99;
         .categories-tree-item{
             justify-content: space-evenly;
             height: 50px;
             line-height: 50px;
             .treeactive{
                color:#1989FA ;
                position: relative;
             }
             .treeactive::after{
                content: '';
                width: 50px;
                height: 3px;
                background: #1989FA;
                position: absolute;
                bottom: 0px;
                left: 0;
             }
         }
        
    }
    .table-toolbar{
        margin-top: 60px;
        margin-bottom: 100px;
         .regulaOption{
                    width: 150px;
                    margin-right: 20px;
                    margin-top: 10px;
                  }
                .exams-list{
                position: relative;
                margin-top: 20px;
                .exams-scrollbar{
                    padding: 0 16px;
                        flex-wrap: wrap;
                    .exams-item{
                        width: 100%;
                        margin-bottom: 16px;
                        padding: 16px 24px;
                        border-radius: 3px;
                        border: solid 1px #e6e6e6;
                        position: relative;
                       .exams-item-paperName{
                        line-height: 30px;
                        margin: 0 16px 0 0;
                        font-size: 20px;
                        font-weight: 700;
                        color: #333!important;
                        transition: color 0.3s;
                        cursor: pointer;
                        word-break: break-all;
                       }
                       .exams-item-info{
                        margin: 10px 0;
                        img{
                           width: 100%;
                        }
                        .exams-item-info-rule{
                            flex: 1;
                            padding: 0 15px;
                            color: #999;
                            position: relative;
                            padding-top: 10px;
                            p{
                                margin-bottom: 10px;
                                padding-bottom: 5px;
                                border-bottom: 1px solid #e6e6e6;
                                 white-space: nowrap;  
                                overflow: hidden;  
                                text-overflow: ellipsis;
                            }
                            .tipImg{
                                position: absolute;
                                top: 25px;
                                left: 50%;
                                transform: translateX(-50%);
                                img{
                                  width: 154px;
                                  height: 122px;
                                transform: rotate(-45deg); 
                                
                                }
                                .jxz{
                                         width: 84px;
                                  height: 82px;
                                transform: rotate(-45deg); 
                                opacity: .2;
                                }
                            }
                        }
                       }
                       .exams-item-line{
                          border-bottom: 1px solid #e6e6e6;
                       }
                       .exams-item-btn{
                        background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%) !important;
                        color: #fff;
                        height: 36px;
                        padding: 0px 18px;
                        border-radius: 4px !important;
                        text-decoration: none !important;
                        white-space: nowrap;
                        cursor: pointer;
                        border: 1px solid #e4e4e4;
                        box-sizing: border-box;
                        line-height: 36px;
                        margin-right: 20px;
                        width: 120px;
                        text-align: center;
                        margin: 20px 0 0 0;
                       }
                       .exams-item-btn1{
                         background-image: linear-gradient(60deg, #e6e6e6 0%, #e6e6e6 100%) !important;
                         color: #999;
                       }
                    }
                             .exams-item:hover{
            border: 1px solid #36aafd;
        }
                }
            }
    }
    .footerExam{
        position: fixed;
        left: 0;
        bottom: 0;
        height: 60px;
        background-color: white;
         box-shadow: #f0f0f0 1px -2px 8px;
         width: 100%;
         justify-content: space-evenly;
         .btnexam{
            .btnexam-icon{
                text-align: center;
                i{
                    font-size: 18px;
                }
            }
         }
         .btnactive{
                        color: #1DA9FF !important;
                    }
    }

}
.watermark{
    .question{
        margin-top: 50px;
        .question-main-content{
            .row{
                .ques-title{
                    vertical-align: middle;
                    -webkit-margin-before: 0;
                    -webkit-margin-after: 0;
                    word-break: break-word; 
                   .ques-number,.ques-type{
                    color: #36aafd;
                   } 
                   .ques-score{
                    color: #aeaeae;
                   }
                }
                .ques-answers{
                    margin-top: 15px;
                    .test_result{
                        justify-content: space-between;
                        .userAnswer{
                            margin-bottom: 20px;
                            color: #666;
                            .test_result_span_title{
                                color: #333;
                                font-size: 16px;
                            }
                            .true{
                                color: green;
                                font-size: 16px;
                            }
                            .false{
                                color: red;
                                font-size: 16px;
                            }
                        }
                        .dnl{
                            span{
                               color: #36aafd
                            }
                        }
                    }
                }
                .jx{
                    color: #999;
                        padding-top: 10px;
                }
            }
        }
    }
}
    .print-tab-content{
    margin-top: 20px;
    .tester-info{
        text-align: center;
        .text{
            margin-bottom: 0px;
            font-size: 20px;
            color: #333;
        }
        .lastP{
            font-size: 14px;
            color: #999;
        }
        .sorceRow{
            margin: 20px  0 10px 0;
            .exam-record-info{
                flex-grow: 1;
                .score-num{
                   color: #333;
                   font-size: 50px;
                   position: relative;
                   font-weight: bold;
                   span{
                    font-size: 14px;
                    
                   }
                //    .UserNum{
                //     position: absolute;
                //     top: 0; 
                //     right: 0;
                //     .pbot{
                //         font-size: 14px;
                //     }
                //    }
                }
            }
        }
    }
}
::v-deep{
         .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>